import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiledropPopupComponent } from '../filedrop-popup/filedrop-popup.component';
import { FormsModule } from '@angular/forms';
//import { HeaderComponent } from '../header/header.component';

@NgModule({
  declarations: [
    FiledropPopupComponent,
  //  HeaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
],
  exports: [
    FiledropPopupComponent,
  ],
  providers: [],
})
export class IntersiteModule { }
